
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import ModelBanner from './Banner.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { ClickEvent } from '@xt/client/types/home.d'

export type ModalInfo = {
  banner: Array<{
    cover: string
    event?: ClickEvent
  }>
  list: Array<{
    cover: string
    event?: ClickEvent
    name: string
  }>
}

@Component({
  components: {
    ModelBanner,
    LazyImg
  }
})
export default class StationeryBagModal extends Vue {
  @Prop({ required: true }) visible: boolean
  @Prop() dataSource: ModalInfo

  showContent: boolean = false

  @Watch('visible')
  onVisibleChange(val: boolean, oldVal: boolean) {
    if (!val) return

    this.showContent = true
  }

  @Emit('click-event')
  handleClickEvent(item) {
    return item
  }

  @Emit('show-qrcode-pop')
  handleShowQrcode(item) {
    return { item, type: 'buy' }
  }

  @Emit('close')
  onClose() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
